.content {
  display: flex;
  flex-direction: column;
  height: 100%;

  .input-search-container {
    height: 64px;
    display: flex;
    align-items: flex-end;
    padding-left: calc(var(--spacer) * 2);
  }
}

#views-input-search {
  margin-bottom: calc(var(--spacer) * 2);
}

.panel-content {
  flex: 2;
  overflow-y: auto;

  .accordion-slot {
    width: calc(100% - 26px);
    align-items: center;
  }

  .accordion-count {
    padding-left: calc(var(--spacer) / 2);
    font-size: var(--body-size);
  }

  .accordion-title {
    text-transform: uppercase;
    font-size: var(--body-size-small);
    font-weight: 600;
  }

  .accordion-title,
  .accordion-count {
    color: var(--chart-302-icon-buttons-titles);
    width: auto;
  }
}

gz-list-item {
  padding-left: calc(var(--spacer) * 2);
  color: var(--main-titles-inputs-600);
}

gz-accordion {
  padding-top: 0;
  --margin--compact-accordion: 0;

  &::part(accordionHeader) {
    padding-left: calc(var(--spacer) * 2);
  }
}

%common-styles {
  font-family: var(--font-family-secondary);
  font-size: var(--body-size-large);
  color: var(--main-titles-inputs-600);
}

.empty-text,
.accordion-item {
  @extend %common-styles;
}

.no-items {
  @extend %common-styles;
  text-align: center;
  padding-left: calc(var(--spacer) * 2);
}
